var Query = (function($) {

  var _s = {
    container: '.chm-block-query',
    query_args_el: '.query-args',
    filters_select_el: 'select[name="filter-select"]',
    filters_list_item_el: $('.chm-block-query .filter'),
    posts_container: $('.chm-block-query .posts-container'),
    page: $('.chm-block-query .pager .page-numbers')
  };



  var _init = function() {
    _bindEvents();
  };



  // ### updateQueryArgs()
  //
  // This function will update the Query Arguments found in the DOM of the
  // block specified with the `container` parameter. It will then trigger
  // and `onchange` event since the the value is contained in a hidden input field.
  var updateQueryArgs = function(container, key, val) {
    if ( !container ) {
      console.error('Function updateQueryArgs(): Query Block container not specified.');
    } else {
      let query_args_container = container.find(_s.query_args_el);
      let query_args = JSON.parse(query_args_container.val());

      query_args[key] = val;

      // Reset page to 1 if anything other than a new page was clicked
      if ( key != 'paged' ) {
        query_args.paged = 1;
      }
      

      query_args_container.val(JSON.stringify(query_args));
      query_args_container.trigger('change');
    }
  };



  // ### getPosts()
  //
  // This function will retrieve the Query Arguments found in the
  // DOM of the block specified with the `container` parameter. It
  // will then make an AJAX call to /inc/lib/ajax/get_posts.php and
  // output the results

  var getPosts = function(container) {
    let query_args = container.find(_s.query_args_el).val();

    $.ajax({
      method: 'POST',
      url: wp_ajax.url, // This variable is set in /inc/lib/dependencies.php
      data: {
        action:'jump_get_posts',
        query_args: JSON.parse(query_args),
      },
      success: function(data) {
        container.find(_s.posts_container).html(data);
      },
      error: function(error) {
        console.log(error);
      },
      complete: function() {
        if ( container.find('.pagination-container').length > 0 ) {
          container.find('.pagination-container').html('');
          container.find('.pagination-container').html(container.find('.pager'));
        } else {
          container.find('.pager').remove();
        }
        
      },
    });
  };



  // ### Events
  var _bindEvents = function() {

    $(_s.container).each(function(i) {
      getPosts($(this));
    });

    // Trigger getPosts() every time the Query Arguments change
    $(_s.query_args_el).on('change', function() {
      let container = $(this).parents(_s.container);
      getPosts(container);
    });

    // Filter
    $(_s.filters_select_el).on('change', function() {
      let container = $(this).parents(_s.container);
      let taxonomy = $(this).parents('[data-taxonomy]').attr('data-taxonomy');
      let term = $(this).val();
      let tax_query = '';
      if ( term != '' ) {
        tax_query = [{
          taxonomy: taxonomy,
          field: 'term_id',
          terms: parseInt(term)
        }];
      }
      
      
      updateQueryArgs(container, 'tax_query', tax_query);
    });

    _s.filters_list_item_el.on('click', function() {
      let container = $(this).parents(_s.container);
      let taxonomy = $(this).parents('[data-taxonomy]').attr('data-taxonomy');
      let term = $(this).attr('data-term-id');
      let tax_query = '';

      $(this).siblings().removeClass('active');
      $(this).toggleClass('active');

      if ( $(this).hasClass('active') ) {
        tax_query = [{
          taxonomy: taxonomy,
          field: 'term_id',
          terms: parseInt(term)
        }];
      }
      
      
      updateQueryArgs(container, 'tax_query', tax_query);
    });

    // New Page Click
    $(document).on('click', 'a.page-numbers', function(e) {
      e.preventDefault();

      let container = $(this).parents(_s.container);
      let param = $(this).attr('href').split("?");
      var page;

      if ( param[1] ) {
        page = param[1].split("=");
        page = page[1];
      } else {
        param[0] = param[0].slice(0, -1); // remove last slash
        page = param[0].substring(param[0].lastIndexOf('/') + 1); // Get everything after the new 'last' slash
      }

      // updateQueryArgs(container, null, parseInt(page));
      updateQueryArgs(container, 'paged', parseInt(page));
    });

  };



  return {
    init: _init
  };

})(jQuery);